import React from "react";
import { LegalLayout, LegalSection } from "./legal/LegalLayout";

export default function ProprieteIntellectuellePage() {
  return (
    <LegalLayout
      testid="propriete-intellectuelle-page"
      eyebrow="Droits & marques"
      title="Propriété intellectuelle"
    >
      <LegalSection title="Contenus du site" testid="section-contenus">
        <p>
          L'ensemble des éléments du site Autopièce Malin (autopiecemalin.fr) —
          structure, textes, interface, graphismes, logo, nom «&nbsp;Autopièce
          Malin&nbsp;», bases de données et code — est la propriété exclusive
          d'Olivier Girault, ou fait l'objet d'une autorisation d'usage. Ces éléments
          sont protégés par le droit de la propriété intellectuelle. Toute
          reproduction, représentation, modification ou exploitation, totale ou
          partielle, sans l'autorisation écrite préalable de l'éditeur, est
          interdite et constitue une contrefaçon.
        </p>
      </LegalSection>

      <LegalSection
        title="Marques et logos des partenaires"
        testid="section-marques"
      >
        <p>
          Les marques, dénominations sociales, logos et noms de produits des sites
          marchands partenaires (notamment Oscaro, Mister Auto, Yakarouler, Autodoc,
          Ovoko et les autres fournisseurs référencés), ainsi que les marques des
          constructeurs automobiles et moto cités, demeurent la propriété exclusive
          de leurs titulaires respectifs. Ces marques et dénominations sont
          utilisées sur le site à seule fin d'information et d'identification, dans
          le cadre de la comparaison de prix et des liens d'affiliation. Cette
          utilisation ne crée aucun lien de partenariat officiel, de parrainage ni
          d'affiliation au sens juridique autre que commercial, et ne saurait être
          interprétée comme une appropriation de ces marques par l'éditeur.
        </p>
      </LegalSection>

      <LegalSection title="Références des pièces" testid="section-references">
        <p>
          Les références de pièces (références constructeur, OEM ou équivalentes)
          sont mentionnées à titre purement informatif, pour permettre
          l'identification des pièces compatibles. Elles restent la propriété de
          leurs titulaires.
        </p>
      </LegalSection>

      <LegalSection title="Signalement" testid="section-signalement">
        <p>
          Tout titulaire de droits estimant qu'un contenu du site porte atteinte à
          ses droits peut en demander le retrait en écrivant à{" "}
          <a
            href="mailto:olivier3835@gmail.com"
            className="text-cyan-300 hover:text-cyan-200 hover:underline"
          >
            olivier3835@gmail.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
